import { Actor, Canvas, Engine, Random, vec } from 'excalibur';
import { DESIGN_WIDTH, SEEDS } from '../utils/constants';
import { Palette } from '../utils/palette';
import { css, sketchStroke, wobblyLinePath } from '../utils/sketch';

export class TimerBar extends Actor {
  ratio = 1;
  danger = false;
  private time = 0;

  constructor() {
    super({
      name: 'timer-bar',
      pos: vec(DESIGN_WIDTH / 2, 154),
      graphic: new Canvas({
        width: 360,
        height: 32,
        cache: false,
        draw: (ctx) => this.paint(ctx),
      }),
    });
  }

  onPreUpdate(_engine: Engine, elapsed: number): void {
    this.time += elapsed / 1000;
  }

  private paint(ctx: CanvasRenderingContext2D): void {
    const rng = new Random(SEEDS.timer);
    const x = 10;
    const y = 8;
    const width = 340;
    const height = 16;
    const ratio = Math.max(0, Math.min(1, this.ratio));
    const fillWidth = Math.max(0, (width - 4) * ratio);
    const fillColor = ratio > 0.5 ? Palette.mint : ratio > 0.25 ? Palette.yellow : Palette.pink;

    if (fillWidth > 4) {
      ctx.save();
      ctx.fillStyle = css(fillColor, 0.85);
      ctx.beginPath();
      if (typeof ctx.roundRect === 'function') {
        ctx.roundRect(x + 3, y + 3, fillWidth, height - 6, 6);
      } else {
        ctx.rect(x + 3, y + 3, fillWidth, height - 6);
      }
      ctx.fill();
      ctx.restore();
    }

    if (this.danger) {
      ctx.save();
      ctx.globalAlpha = 0.16 + (Math.sin(this.time * 8) + 1) * 0.13;
      ctx.fillStyle = css(Palette.pinkDeep);
      ctx.fillRect(x + 3, y + 3, width - 6, height - 6);
      ctx.restore();
    }

    for (let i = 1; i < 10; i++) {
      const tickX = x + 2 + ((width - 4) * i) / 10;
      sketchStroke(ctx, rng, { color: Palette.ink, width: 1.4, alpha: 0.22 }, (c) =>
        wobblyLinePath(c, tickX, y + 2, tickX, y + height - 2, rng, 0.6, 2), 1);
    }

    const borderStyle = { color: Palette.ink, width: 3, alpha: 0.75 };
    sketchStroke(ctx, rng, borderStyle, (c) => wobblyLinePath(c, x, y, x + width, y, rng, 1.2, 14), 2, 1);
    sketchStroke(ctx, rng, borderStyle, (c) =>
      wobblyLinePath(c, x + width, y, x + width, y + height, rng, 1.2, 4), 2, 1);
    sketchStroke(ctx, rng, borderStyle, (c) =>
      wobblyLinePath(c, x + width, y + height, x, y + height, rng, 1.2, 14), 2, 1);
    sketchStroke(ctx, rng, borderStyle, (c) => wobblyLinePath(c, x, y + height, x, y, rng, 1.2, 4), 2, 1);
  }
}
